import { render, staticRenderFns } from "./BulkActionsReportV2.vue?vue&type=template&id=61704318&scoped=true&lang=pug"
import script from "./BulkActionsReportV2.vue?vue&type=script&lang=js"
export * from "./BulkActionsReportV2.vue?vue&type=script&lang=js"
import style0 from "./BulkActionsReportV2.vue?vue&type=style&index=0&id=61704318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61704318",
  null
  
)

export default component.exports